<template>
  <div class="wrapper">
    <div class="header">
      <h1>{{title}}</h1>
      <a-button ghost type="primary" @click="back">返回</a-button>
    </div>
    <div class="container" id="modalBox">
      <template v-if="windows == 'layout'">
        <a-layout>
          <a-layout-header style="background-color: #fff; padding: 0">
            <div class="headers">
              <div class="flex flex_a">
                <SiderView :selected="selected" />
              </div>
              <div>
                郑晓晓
                <img src="@/assets/img/user.png" alt="" width="32" class="ml8">
              </div>
            </div>
          </a-layout-header>
          <a-layout-content id="refBox">
            <slot></slot>
          </a-layout-content>
        </a-layout>
      </template>
      <template v-if="windows == 'full'">
        <slot></slot>
      </template>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
import { LeftOutlined } from '@ant-design/icons-vue';
import SiderView from "./SiderView.vue";
import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  breadcrumb: {
    type: Array,
    default: [],
  },
  selected: {
    type: Array,
    default: ['sub0'],
  },
  type: {
    type: String,
    default: 'seal',
  },
  windows: {
    type: String,
    default: 'layout',
  }
});
const back = () => {
  router.push({
    name: "home",
  });
}
</script>
<style lang="less" scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
  background: url("@/assets/img/bg.png") no-repeat top center;
  .header {
    width: 1280px;
    height: 107px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-size: 24px;
      margin-bottom: 0;
      font-weight: bold;
    }
  }
}
.container {
  width: 1260px;
  height: 740px;
  background: #f9f9f9;
  border-radius: 10px;
  margin: 0 auto;
  overflow: hidden;
  /deep/.ant-layout-header {
    background: #fff;
    box-shadow: 1px 0px 10px 0px rgba(0, 0, 0, 0.06);
    padding: 0 16px;
    z-index: 1;
    position: relative;
    .headers {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      span {
        font-size: 16px;
      }
    }
  }
  /deep/.ant-layout {
    transition: all 0.2s;
    background: #f9f9f9;
    height: 100%;
  }
  /deep/.ant-layout-content {
    overflow: auto;
  }
  /deep/.ant-layout-sider {
    background-color: #fff;
    box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.08);
    z-index: 2;
    position: relative;
  }
}
</style>